import {
  RbacConfig,
  RbacCurrentUser,
  RbacManagedUser,
  RbacPermissionSet,
  RbacPermissions,
  RbacRole,
} from "./rbac.types";

// Tolerant of the backend renaming/casing keys differently — e.g. the real
// API sends role.roleId/role.roleName, not role.id/role.name — so the rest
// of the app never has to know or care what the API actually sent.
export const mapRole = (role: any): RbacRole => ({
  id: role?.roleId ?? role?.RoleId ?? role?.id ?? role?.Id ?? 0,
  name: role?.roleName ?? role?.RoleName ?? role?.name ?? role?.Name ?? "",
});

export const mapPermissionSet = (permissionSet: any): RbacPermissionSet => ({
  view: permissionSet?.view ?? permissionSet?.View ?? false,
  create: permissionSet?.create ?? permissionSet?.Create ?? false,
  edit: permissionSet?.edit ?? permissionSet?.Edit ?? false,
  delete: permissionSet?.delete ?? permissionSet?.Delete ?? false,
  invite: permissionSet?.invite ?? permissionSet?.Invite ?? false,
});

export const mapCurrentUser = (currentUser: any): RbacCurrentUser => ({
  // Real API sends userId, not id.
  id: currentUser?.userId ?? currentUser?.UserId ?? currentUser?.id ?? currentUser?.Id ?? "",
  email: currentUser?.email ?? currentUser?.Email ?? "",
  firstName: currentUser?.firstName ?? currentUser?.FirstName ?? "",
  lastName: currentUser?.lastName ?? currentUser?.LastName ?? "",
  // currentUser.role can be null (e.g. role not yet assigned) — mapRole({})
  // still returns a well-shaped RbacRole (id: 0, name: "") instead of crashing.
  role: mapRole(currentUser?.role ?? currentUser?.Role ?? {}),
});

export const mapManagedUser = (user: any): RbacManagedUser => ({
  id: user?.userId ?? user?.UserId ?? user?.id ?? user?.Id ?? "",
  firstName: user?.firstName ?? user?.FirstName ?? "",
  lastName: user?.lastName ?? user?.LastName ?? "",
  email: user?.email ?? user?.Email ?? "",
  role: mapRole(user?.role ?? user?.Role ?? {}),
  canEdit: user?.canEdit ?? user?.CanEdit ?? false,
  canDelete: user?.canDelete ?? user?.CanDelete ?? false,
  status: user?.status ?? user?.Status ?? 545,
});

export const mapPermissions = (permissions: any): RbacPermissions => ({
  userManagement: mapPermissionSet(
    permissions?.userManagement ?? permissions?.UserManagement ?? {}
  ),
  clientManagement: mapPermissionSet(
    permissions?.clientManagement ?? permissions?.ClientManagement ?? {}
  ),
});

export const mapRbacConfig = (raw: any): RbacConfig => {
  const assignableRoles = raw?.assignableRoles ?? raw?.AssignableRoles ?? [];
  const users = raw?.users ?? raw?.Users ?? [];

  return {
    currentUser: mapCurrentUser(raw?.currentUser ?? raw?.CurrentUser ?? {}),
    permissions: mapPermissions(raw?.permissions ?? raw?.Permissions ?? {}),
    assignableRoles: Array.isArray(assignableRoles)
      ? assignableRoles.map(mapRole)
      : [],
    users: Array.isArray(users) ? users.map(mapManagedUser) : [],
  };
};